export default {
  header: 'Wir müssen deine Telefonnummer verifizieren',
  remember_device: {
    label: 'Dieses Gerät {{days}} Tage lang merken',
  },
  buttons: {
    confirm: 'Bestätigen',
  },
  toasts: {
    invalid_code: 'Ungültiger Code. Bitte versuche es erneut.',
  },
};
